export const FaceBookPixelID = {
    dk: '763147240473587',
    se: '763147240473587',
    no: '763147240473587',
    da: '763147240473587'
}